<template>
  <section>
    <div class="container">
      <div class="c-boxcontainer__header">
        <h1 class="c-boxcontainer__title">
          {{ $t("Scopri come funziona Fanize") }}
        </h1>
      </div>
      <div class="c-boxcontainer__content">
        <template v-for="(box, index) in boxes">
          <Box
            v-bind:key="index"
            v-bind:icon="box.icon"
            v-bind:title="box.title"
            v-bind:number="box.number"
          ></Box>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import Box from "./Box";

export default {
  components: {
    Box
  },
  data() {
    return {
      boxes: [
        {
          icon: "static/tempAssets/icon1.svg",
          title: this.$i18n.t("Accedi e registrati alla piattaforma"),
          subtitle: "",
          number: "1"
        },
        {
          icon: "static/tempAssets/icon2.svg",
          title: this.$i18n.t("Partecipa alle missioni settimanali"),
          subtitle: "",
          number: "2"
        },
        {
          icon: "static/tempAssets/icon3.svg",
          title: this.$i18n.t("Accumula punti e scala la classica"),
          subtitle: "",
          number: "3"
        },
        {
          icon: "static/tempAssets/icon4.svg",
          title: this.$i18n.t("Vinci premi ed esperienze esclusive"),
          subtitle: "",
          number: "4"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins.scss";

.c-boxcontainer__header {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 2rem 1rem;
  @include lg {
    margin: 3rem auto;
    max-width: 70%;
  }
}
.c-boxcontainer__content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 3rem;
  @include lg {
    flex-direction: row;
  }
}
.c-boxcontainer__title {
  font-size: 32px;
  @include lg {
    font-size: 48px;
  }
}
</style>
